import { Component } from '@angular/core';

@Component({
  selector: 'app-main-remittances',
  templateUrl: './main-remittances.component.html',
  styleUrls: ['./main-remittances.component.css'],
})
export class MainRemittancesComponent {}
